import React from "react";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { updateBalance } from "../../reducers/users";

const BalanceModal = (props) => {
  const dispatch = useDispatch();

  const modalClose = () => {
    props.closeModal(false);
  }
    // Schema for yup
  const validationSchema = Yup.object().shape({
    balance: Yup.string()
      .required("*Balance is required"),
    terms: Yup.boolean()
        .oneOf([true], "You must check that you understand")
  });

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Balance<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Formik 
        initialValues={{balance: props.initialBalance, terms: false, userId: props.userId }}
        validationSchema={validationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
            console.log("VALUES", values);
            dispatch(updateBalance(values));
            props.closeModal(false);
        }}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting }) => (
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(e)}}>
              <Form.Group className="mb-3" controlId="balance">
                <Form.Label>Balance</Form.Label>
                <Form.Control 
                  name="balance"
                  type="text"
                  placeholder="New Balance"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.balance}
                  className={touched.balance && errors.balance ? "error" : null}
                />
                {touched.balance && errors.balance ? (
                  <div className="error-message">{errors.balance}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="terms">
                <Form.Check 
                  name="terms"
                  type="checkbox"
                  label="I understand that this action will add or remove funds from the user's account." 
                  onChange={e => setFieldValue('terms', e.target.checked)}
                  onBlur={handleBlur}
                  checked={values.terms}
                  className={touched.terms && errors.terms ? "error" : null}
                />
                {touched.terms && errors.terms ? (
                  <div className="error-message">{errors.terms}</div>
                ): null}
              </Form.Group>

              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  Update Balance
                </Button>
              </Modal.Footer>
            </Form>  
      )}
    </Formik>
    </Modal.Body>
    </Modal>
  );
};

export default BalanceModal; 